import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';
import { fetchHandler } from '../../utils/apiUtils';
import { transformToClientAccessList } from '../../utils/screenPermission';
import { isEmpty } from 'lodash';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.PortalAPIUrl,
});

const searchCylinder = async ({
  clientIDs,
  orderNumber,
  rentalAgreementNumber,
  cylinderType,
  cylinderStatus,
  cylinderSubStatus,
  requestor,
  reportAddressIDs,
  scenarioIDs,
  daysOut,
  shippingDateFrom,
  shippingDateTo,
  clientAccessList,
  returnDueDateFrom,
  returnDueDateTo,
  page,
  pageSize,
  sortBy,
  sortDirection,
  functionality,
  cylinderIDs
}, abortController) => {
  const clientAccessFilter = transformToClientAccessList(clientIDs, reportAddressIDs, scenarioIDs);
  return fetchHandler(axiosInstance,
    '/CylinderMovement/Search/By', {
      orderNumber,
      rentalAgreementNumber,
      cylinderTypeID: cylinderType,
      statusIDs: cylinderStatus,
      subStatusIDs: cylinderSubStatus,
      requestor,
      clientAccessList,
      daysOutRange: daysOut,
      clientAccessFilter: clientAccessFilter ? JSON.stringify(clientAccessFilter) : null,
      shippedDateFrom: shippingDateFrom,
      shippedDateTo: shippingDateTo,
      returnDueDateFrom,
      returnDueDateTo,
      currentPage: page,
      pageSize,
      sortBy,
      sortDirection,
      functionality: functionality || 'Cylinder',
      cylinderIDs
    }, abortController);
};

const getDaysOut = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/DaysOut', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getCylinderByState = async ({ clientIds,
  divisionIds,
  locationIds,
  clientAccessList,
  scenarioIds,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/CylinderByState', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getCylinderByType = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/CylinderByType', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      addressTypeIds: addressTypeIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getLateFeesBilledYTD = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/LateFeesBilledYTD', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getRentalFeesByClient = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/RentalFeesByClient', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getLateFeesPending = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/LateFeesPending', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getLateFeesPendingByClient = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    'DashBoard/LateFeePendingByClient', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getCylinderActivityByClient = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  addressTypeIds,
  clientAccessList,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/CylinderActivityByClient', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getCylinderActivityByRequestor = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  addressTypeIds,
  clientAccessList,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/CylinderActivityByRequestor', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      addressTypeIds: addressTypeIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getClientCylinderByStatus = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    'DashBoard/ClientCylinderByStatus', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getClientCylinderReturnTime = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/GetClientCylinderReturnTime', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getClientCylinderTotalRepairFees = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/GetClientCylinderTotalRepairFees', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      addressTypeIds: addressTypeIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getOrderByStatus = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/GetOrdersByStatus', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      addressTypeIds: addressTypeIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getRecentOrders = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/GetRecentOrders', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getOrderbyShipLocation = async ({ dateFrom,
  dateTo,
  clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  clientAccessList,
  addressTypeIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/GetOrderbyShipLocation', { dateFrom,
      dateTo,
      clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getOrderbyMaterialAndStatus = async ({ clientIds,
  divisionIds,
  locationIds,
  scenarioIds,
  addressTypeIds,
  sourceSystemIds,
  clientAccessList,
  latitude,
  longitude }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/GetOrderbyMaterialAndStatus', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      scenarioIds: scenarioIds?.join(','),
      addressTypeIds: addressTypeIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','),
      clientAccessFilter: isEmpty(clientAccessList) ? null : JSON.stringify({ ClientAccessList: clientAccessList }),
      latitude,
      longitude }, abortController);

const cylinderApi = {
  searchCylinder,
  getDaysOut,
  getCylinderByState,
  getCylinderByType,
  getLateFeesBilledYTD,
  getRentalFeesByClient,
  getLateFeesPending,
  getLateFeesPendingByClient,
  getCylinderActivityByClient,
  getCylinderActivityByRequestor,
  getClientCylinderByStatus,
  getClientCylinderReturnTime,
  getClientCylinderTotalRepairFees,
  getOrderByStatus,
  getRecentOrders,
  getOrderbyShipLocation,
  getOrderbyMaterialAndStatus,
};

export default cylinderApi;
